import User, { hasRole, Role } from '@/models/User'

export default class UserPolicy {
	viewAny(_user: User): boolean {
		return true
	}

	view(user: User, model: User): boolean {
		switch (user.role) {
			case Role.USER:
				return user.company?.id === model.company?.id
			case Role.AUDITOR:
				return user.auditor?.id === model.auditor?.id
			case Role.ADMIN:
			case Role.MANAGER:
			case Role.REGULATOR:
				return true
			default:
				return false
		}
	}

	create(user: User): boolean {
		return hasRole(user, [Role.ADMIN, Role.MANAGER])
	}

	update(user: User, model: User): boolean {
		if (hasRole(user, [Role.ADMIN, Role.MANAGER])) {
			return true
		}

		switch (user.role) {
			case Role.USER:
				return user.company?.id === model.company?.id
			case Role.AUDITOR:
				return user.auditor?.id === model.auditor?.id
			default:
				return false
		}
	}

	restore(user: User, model: User): boolean {
		if (hasRole(user, [Role.ADMIN, Role.MANAGER])) {
			return true
		}

		switch (user.role) {
			case Role.USER:
				return user.company?.id === model.company?.id
			case Role.AUDITOR:
				return user.auditor?.id === model.auditor?.id
			default:
				return false
		}
	}

	delete(user: User, model: User): boolean {
		if (user.id === model.id) {
			return false
		}

		if (hasRole(user, [Role.ADMIN, Role.MANAGER])) {
			return true
		}

		switch (user.role) {
			case Role.USER:
				return user.company?.id === model.company?.id
			case Role.AUDITOR:
				return user.auditor?.id === model.auditor?.id
			default:
				return false
		}
	}

	forceDelete(_user: User, _model: User): boolean {
		return false
	}

	suspend(user: User, model: User): boolean {
		if (user.id === model.id) {
			return false
		}

		return hasRole(user, [Role.ADMIN, Role.MANAGER])
	}

	role(user: User, model: User): boolean {
		if (user.id === model.id) {
			return false
		}

		if (hasRole(user, [Role.ADMIN, Role.MANAGER])) {
			return true
		}

		switch (user.role) {
			case Role.USER:
				return user.company?.id === model.company?.id && hasRole(model, Role.USER)
			case Role.AUDITOR:
				return user.auditor?.id === model.auditor?.id && hasRole(model, Role.AUDITOR)
			default:
				return false
		}
	}
}
